import { stringLiteral } from '@execonline-inc/decoders';
import { Decoder, array, field, number, oneOf, succeed } from 'jsonous';
import { resourceDecoder } from '../../../../../../../Resource/Decoders';
import { invitationResourceDecoder } from '../../../Store/Decoders';
import { BulkInvitations, BulkInvitationsResource, InvitationStatus } from './Types';

export const invitationStatusDecoder: Decoder<InvitationStatus> = oneOf([
  stringLiteral<InvitationStatus>('active'),
  stringLiteral<InvitationStatus>('inactive'),
]);

const bulkInvitationsDecoder: Decoder<BulkInvitations> = succeed({})
  .assign('attemptedCount', field('attempted_count', number))
  .assign('successCount', field('success_count', number))
  .assign('invitationStatus', field('invitation_status', invitationStatusDecoder))
  .assign('updatedInvitations', field('updated_invitations', array(invitationResourceDecoder)));

export const bulkInvitationsResourceDecoder: Decoder<BulkInvitationsResource> =
  resourceDecoder(bulkInvitationsDecoder);
